const NEWLINE_VALIDATOR = /^\s+|\s+$/gm;

export const inlineScriptSrcGenerator = (string: string) => `data:text/javascript,${string.replace(NEWLINE_VALIDATOR, '')}`;
